import React from 'react'
import {LoggerProps, withLogger} from './withLogger'
import {withPageTitle} from './withPageTitle'
import {withScroller} from './withScroller'
import {withLoadingSpinner} from './withLoadingSpinner'
import EventEmitterExResident from '../pageBaseComponents/EventEmitterExResident'
import {AsyncCommunicationProps, withAsyncCommunication} from './withAsyncCommunication'
import {withResidentPageTemplate} from './withResidentPageTemplate'
import {RouterPageProps} from '../RouterPropsInjector'

export type ResidentWithErrorHandlingPagePropsSet =
    LoggerProps &
    AsyncCommunicationProps &
    RouterPageProps &
    { eventEmitter: EventEmitterExResident }

export const createResidentWithErrorHandlingPage = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps & ResidentWithErrorHandlingPagePropsSet>,
) =>
    withLogger(
        WrappedComponent.displayName || 'undefined',
        withResidentPageTemplate(withScroller(
            withAsyncCommunication(
                withPageTitle(
                    withLoadingSpinner(
                        WrappedComponent)))))
        ,
    )
